export default {
    SharingTipsIgnoreExpirationInfoBarClicked: {
        datapoint: {
            name: 'SharingTipsIgnoreExpirationInfoBarClicked',
        },
    },
    SharingTipsRefreshExpirationInfoBarClicked: {
        datapoint: {
            name: 'SharingTipsRefreshExpirationInfoBarClicked',
        },
    },
};
